import type { IFieldConfiguration } from '@sravni/cosago-react-library/lib/types';

import { OneFieldRegistrationAddress } from 'shared/ui/AddressFields/OneFieldRegistrationAddress';

import type { TPassportFormFields } from 'entities/creditForm';

import {
  AddressFlat,
  BirthDateField,
  BirthPlace,
  DateField,
  PassportIssueDateField,
  PassportIssuedBy,
  PassportSeriesNumber,
  Region,
  ResidenceAddressIsRegistration,
  UnitCode,
  PersonFioField,
} from './ui/fields';

export interface IPassportInfoMobileConfig extends Omit<IFieldConfiguration, 'fieldName'> {
  fieldName: keyof TPassportFormFields;
}

export const FormFieldsControls: Record<keyof TPassportFormFields, React.ReactNode> = {
  passportIssueDate: PassportIssueDateField,
  birthDate: BirthDateField,
  birthPlace: BirthPlace,
  passportNumber: PassportSeriesNumber,
  passportIssuedBy: PassportIssuedBy,
  unitCode: UnitCode,
  registrationAddress: OneFieldRegistrationAddress,
  registrationLocationRoute: null,
  registrationAddressFlat: AddressFlat,
  registrationDate: DateField,
  residenceAddress: OneFieldRegistrationAddress,
  residenceLocationRoute: null,
  residenceAddressFlat: AddressFlat,
  residenceAddressIsRegistration: ResidenceAddressIsRegistration,
  region: Region,
  regionLocationRoute: null,
  regionLocation: null,
  fullName: PersonFioField,
  gender: null,
};

export const FormFieldsNavigationSequence: IPassportInfoMobileConfig[] = [
  {
    fieldName: 'fullName',
    required: true,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'birthDate',
    required: true,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'birthPlace',
    required: true,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'passportNumber',
    required: true,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'passportIssuedBy',
    required: true,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'passportIssueDate',
    required: true,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'unitCode',
    required: true,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'registrationAddress',
    required: true,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'registrationAddressFlat',
    required: false,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'registrationDate',
    required: true,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'residenceAddress',
    required: true,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'residenceAddressFlat',
    required: false,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'residenceAddressIsRegistration',
    required: true,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'region',
    required: true,
    checkShouldMoveToNextField: true,
  },
];
